import styled from "styled-components";

import { FlexContainer, FlexDiv, FlexSection } from "../../../components/Atoms";

export const Container = styled(FlexContainer)`
  flex-direction: column;
  padding: 0 32px;
  @media only screen and (max-width: 1023px) {
    padding: 0 16px;
  }
`;
export const InnerWrapper = styled(FlexDiv)`
  padding: 16px 24px;
  background-color: ${({ theme }) => theme.colorsV2.shyft.purple_text};
  border-radius: 8px;
  border: ${({ theme }) => theme.colorsV2.primary.shade_700};
  @media only screen and (max-width: 767px) {
    padding: 16px;
  }
`;
export const Wrapper = styled(FlexSection)`
  ${({ isStickyHeader, theme }) =>
    isStickyHeader &&
    `
    opacity: 0;
    visibility: hidden;
    padding: 20px 0 28px;
    position:fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    right:0;
    box-shadow: 0px 0px 4px rgba(${theme.colors.shadows.black}, 0.04), 0px -4px 8px rgba(${theme.colors.shadows.black}, 0.06);
    z-index:3;
    @media only screen and (max-width: 992px) {
      padding: 16px 0;
      opacity: 1;
      visibility: visible;
    }
    ${InnerWrapper} {
        padding: 0;
        background-color: transparent;
        border-radius: 0px;
        border: 0px;
      }
  `}
  ${({ isDark, theme }) =>
    !isDark &&
    `
    background-color: ${theme.colorsV2.blueGray.shade_50};
`}
`;
